import { render, staticRenderFns } from "./ClientMissionProfile.vue?vue&type=template&id=23cbbbd2&"
import script from "./ClientMissionProfile.vue?vue&type=script&lang=js&"
export * from "./ClientMissionProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports